// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__31csL","MiniSpinner":"Spinner_MiniSpinner__3Dnfa","Spin":"Spinner_Spin__2vcAn"};